import styled from "styled-components";

export const InstantReqPageWaitingStyled = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;

  & > .inner {
    display: flex;
    flex-direction: column-reverse;
    width: 270px;
    margin: auto;

    .inner__white {
      padding: 12px;
      border-radius: 16px;
      width: 100%;
      background-color: #ffffff;
      margin: 5px 0;
      font-weight: bold;
      text-align: center;
      font-size: 1.1em;
    }
  }

  .cancel-btn {
    border-radius: 10px;
    font-size: 0.85em;
    background-color: #ed5565;
    width: 270px;
  }

  .item-1 {
    opacity: 0.6;
  }
  .item-2 {
    opacity: 0.3;
  }
`;
